import type { ReactElement, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAppSelector } from '@/app/store/hooks';
import { selectIsAuthenticated } from '@/features/auth';

interface ProtectedRouteProps {
  readonly children: ReactNode;
}

/**
 * Bloquea el render hasta confirmar sesión. Si no hay sesión, redirige
 * a /login conservando la ruta intentada en `?next=…` para volver tras login.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps): ReactElement {
  const location = useLocation();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return <>{children}</>;
}
